import { SWATID_MAX_SLOTS_PER_DAY, SWATID_VALID_MINUTES } from '@/constants/swatid';

export function isValidSwatidTime(time: string): boolean {
  const match = /^(\d{1,2}):(\d{2})$/.exec(time);
  if (!match) return false;
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  return (
    hours >= 0 &&
    hours <= 23 &&
    (SWATID_VALID_MINUTES as readonly number[]).includes(minutes)
  );
}

export function canAddSwatidSchedule(currentCount: number): boolean {
  return currentCount < SWATID_MAX_SLOTS_PER_DAY;
}

export function formatTimerRemaining(seconds: number): string {
  if (seconds <= 0) return '';
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return m > 0 ? `${m}:${s.toString().padStart(2, '0')}` : `${s}s`;
}

export const sleep = (ms: number) => new Promise<void>((resolve) => setTimeout(resolve, ms));
